import _groupBy from 'lodash/groupBy';
import _property from 'lodash/property';
import _isEmpty from 'lodash/isEmpty';
import _forEach from 'lodash/forEach';

import editFullAttendanceTemplate from './../edit-full-attendance/edit-full-attendance.html';
import viewAttendanceTemplate from './../view-attendance/view-attendance.html';
import template from './timeline.html';

import './timeline.scss';

class TimelineComponent {
  /** @ngInject */
  constructor(
    $log, $scope, $compile, $mdDialog, $mdToast, moment,
    AttendanceService,
    CategoryOfDepartureService,
    UtilService
  ) {
    this.$log = $log;
    this.$scope = $scope;
    this.$compile = $compile;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.AttendanceService = AttendanceService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
    this.UtilService = UtilService;

    this.hours = [];
    this.template = `
      <ul class="librus-timeline__events" ng-repeat="event in events">
        <li>
          <span>{{event[0].student.fullName}}</span>
          <span>({{event[0].student.groupName}})</span>
        </li>
        <li>
          <span ng-repeat="item in event" class="librus-timeline__single-event" ng-class="{'invalid-item': item.invalid}" ng-click="edit(item)" ng-style="{'position':'absolute', 'left':item.positionX, 'display':'inline-block', 'width':item.duration}">
            <span>{{item.startTime}} - {{item.endTime}}</span>
            <md-tooltip md-direction="bottom">{{item.startTime}} - {{item.endTime}}</md-tooltip>
          </span>
        </li>
      </ul>
    `;
  }

  $onInit() {
    this.setHours();
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.options) {
      this.options = {...this.options};
    }

    if (changes.events) {
      this.events = Object.assign([], this.events);
      this.events = _groupBy(this.events, _property('student.id'));
      if (!_isEmpty(this.events)) {
        this.setHours();
        this.events = this.createEvents(this.events);
      }
    }

    if (changes.categoriesOfDeparture) {
      this.categoriesOfDeparture = Object.assign([], this.categoriesOfDeparture);
    }
  }

  setHours() {
    this.hours.splice(0, this.hours.length);
    let minTime = this.UtilService.parseTime(this.options.minTime);
    const maxTime = this.UtilService.parseTime(this.options.maxTime);
    const slotDuration = this.options.slotDuration.split(':');
    while (minTime <= maxTime) {
      minTime = this.moment(minTime);
      this.hours.push(minTime.format('HH:mm'));
      minTime.add({hours: slotDuration[0], minutes: slotDuration[1]});
    }
  }

  render() {
    this.createEvents(this.events);
  }

  createEvents(events) {
    const minTime = this.getScheduleTimestamp(this.options.minTime);
    const maxTime = this.getScheduleTimestamp(this.options.maxTime);
    const slotDuration = this.getScheduleTimestamp(this.options.slotDuration);
    const scope = this.$scope.$new(true);
    _forEach(events, event => {
      _forEach(event, item => {
        let startTime = this.getScheduleTimestamp(item.startTime);
        let endTime = this.getScheduleTimestamp(item.endTime);
        if (minTime > startTime) {
          startTime = minTime;
        }

        if (maxTime < endTime) {
          endTime = maxTime;
        }

        const duration = (this.options.slotWidth * (endTime - startTime)) / slotDuration;
        const posX = ((startTime - minTime) / slotDuration) * this.options.slotWidth;
        item.positionX = 0;
        if (posX > 0) {
          item.positionX = posX;
        }

        item.duration = duration;
      });
    });
    scope.events = events;
    scope.edit = event => {
      if (Number(event.employee.id) === this.me.employeeId) {
        this.AttendanceService.get(event.student.id, event.id).then(attendance => {
          this.openDialog(attendance, editFullAttendanceTemplate).then(result => {
            _forEach(scope.events, (item, idx) => {
              if (item[0].id === result.id) {
                if (this.moment(event.date).isSame(result.date)) {
                  Object.assign(item[0], result);
                } else {
                  delete this.events[idx];
                }

                this.createEvents(this.events);
              }
            });
          });
        });
      } else if (event.additionalInfo.registeredBy.userId === this.me.userId && event.endTime) {
        this.AttendanceService.get(event.student.id, event.id).then(attendance => {
          this.openDialog(attendance, viewAttendanceTemplate);
        });
      } else if (event.additionalInfo.deregisteredBy && event.additionalInfo.deregisteredBy.userId === this.me.userId && event.endTime) {
        this.AttendanceService.get(event.student.id, event.id).then(attendance => {
          this.openDialog(attendance, viewAttendanceTemplate);
        });
      } else {
        return this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {
              error: {
                MessagePL: 'Nie można edytować frekwencji',
                Errors: [`Wybrany wpis został dodany przez pracownika: ${event.employee.fullName}.`]
              }
            }
          })
        );
      }
    };

    const list = this.$compile(this.template)(scope);
    angular.element('.librus-timeline__events-container').html(list);
    return events;
  }

  getScheduleTimestamp(time) {
    time = time.replace(/ /g, '');
    const timeArray = time.split(':');
    const timeStamp = (parseInt(timeArray[0], 10) * 60) + parseInt(timeArray[1], 10);
    return timeStamp;
  }

  /*
    @param attendance - attendance related with calendar event
    @param template - dialog template
  */
  openDialog(attendance, template) {
    return this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditFullAttendanceController',
      locals: {attendance: attendance[0], categoriesOfDeparture: this.categoriesOfDeparture},
      template
    });
  }
}

export const Timeline = {
  bindings: {
    me: '<',
    options: '<',
    events: '<',
    categoriesOfDeparture: '<'
  },
  template,
  controller: TimelineComponent
};
